module.exports = __webpack_public_path__ + "img/features5.60601252.png";